import { Helmet } from 'react-helmet';
// Cambiar la línea de importación:
import { generateSEOMetadata } from '../../content'; // ✅ CORREGIDO

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  author,
  publishedTime,
  modifiedTime,
  section,
  tags,
  locale = 'es_MX',
  siteName = 'Zero Latency',
  twitterHandle = '@zerolatency',
  noindex = false,
  nofollow = false,
  canonical,
  alternateLanguages = [],
  structuredData,
  page
}) => {
  // Si se proporciona 'page', obtener configuración automáticamente
  const config = page ? generateSEOMetadata(page) : {};
  
  // Combinar props con configuración de página
  const finalTitle = title || config.title;
  const finalDescription = description || config.description;
  const finalKeywords = keywords || config.keywords;
  const finalImage = image || config.image;
  const finalUrl = url || config.url;
  
  const robotsContent = [
    noindex ? 'noindex' : 'index',
    nofollow ? 'nofollow' : 'follow'
  ].join(', ');

  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": siteName,
    "url": finalUrl,
    "description": finalDescription,
    "image": finalImage
  };

  return (
    <Helmet>
      {/* Título */}
      <title>{finalTitle}</title>
      
      {/* Meta tags básicos */}
      <meta name="description" content={finalDescription} />
      {finalKeywords && <meta name="keywords" content={finalKeywords} />}
      <meta name="author" content={author || 'Zero Latency'} />
      <meta name="robots" content={robotsContent} />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />
      {finalImage && <meta property="og:image" content={finalImage} />}
      {finalImage && <meta property="og:image:alt" content={finalTitle} />}
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {section && <meta property="article:section" content={section} />}
      {tags && tags.map(tag => (
        <meta key={tag} property="article:tag" content={tag} />
      ))}
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      {finalImage && <meta name="twitter:image" content={finalImage} />}
      
      {/* Idiomas alternativos */}
      {alternateLanguages.map(({ lang, url }) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={url} />
      ))}
      
      {/* Preconnect para optimización */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {/* Favicons */}
      <link rel="icon" type="image/svg+xml" href="/zero_logo.svg" />
      <link rel="apple-touch-icon" href="/zero_logo.svg" />
      
      {/* Web App Manifest */}
      <link rel="manifest" href="/site.webmanifest" />
      
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData || defaultStructuredData)}
      </script>
    </Helmet>
  );
};

export { SEO };
export default SEO;